import { useSelector } from "react-redux";

export function useCheckCategoryAccess(categoryName, url) {
  const { permissions, roleId, wlOtcEnabled } = useSelector((state) => state.auth);

  const freeAccessed = ["MY_ACCOUNT", "API", "WALLETS"];
  if (freeAccessed.some(elem => elem === categoryName)) {
    return true;
  } else if (categoryName === "PRICING") {
    return roleId === "MERCHANT_ADMIN";
  } if (categoryName === "MERCHANT FINANCE SECTION" && url === "/otc-settlement") {
    return wlOtcEnabled;
  }

  const foundPermissions = permissions.filter(elem => elem.category === categoryName);
  return foundPermissions?.some(elem => elem.state);
}